import * as _ from 'lodash';
import {
  CREATE_DELIVERYS_SUCCEEDED,
  CLEAR_PRODUCT_DELIVERY,
  REMOVE_DATA_DELIVERY,
  ADD_DATA_DELIVERY,
  TOGGLE_COLLAPSE_DATA_DELIVERY
} from './create.actions';

export const create = (state = { created: false, data: [], address: null, delivery_type: null, object_type: null, customer: null }, action) => {
  switch (action.type) {
    case ADD_DATA_DELIVERY:
      if (state.object_type !== action.data.object_type || state.delivery_type !== action.data.delivery_type) {
        return _.assign({}, state, {
          data: [
            {
              'object_id': action.data.content.id,
              'details': action.data.content
            }
          ],
          address: action.data.content.getDefaultAddress(),
          customer: action.data.content.getDefaultCustomer(),
          delivery_type: action.data.delivery_type,
          object_type: action.data.object_type
        });
      } else {
        let isDataExist = state.data.find(s => s.object_id === action.data.content.id);
        if (isDataExist) {
          return _.assign({}, state, {
            data: [
              ...state.data
            ],
            address: action.data.content.getDefaultAddress(),
            customer: action.data.content.getDefaultCustomer(),
            delivery_type: action.data.delivery_type,
            object_type: action.data.object_type
          });
        } else {
          return _.assign({}, state, {
            data: [
              ...state.data,
              {
                'object_id': action.data.content.id,
                'details': action.data.content
              }
            ],
            address: action.data.content.getDefaultAddress(),
            customer: action.data.content.getDefaultCustomer(),
            delivery_type: action.data.delivery_type,
            object_type: action.data.object_type
          });
        }
      }

    case TOGGLE_COLLAPSE_DATA_DELIVERY:
      return _.assign({}, state, {
        data: [
          ...(action.key === 0 ? [] : state.data.slice(0, action.key - 1)),
          _.assign({}, state.data[action.key], {
            closed: !state.data[action.key].closed
          }),
          ...(action.key === state.data.length - 1 ? [] : state.data.slice(action.key + 1))
        ]
      });

    case REMOVE_DATA_DELIVERY:
      return _.assign({}, state, {
        data: [
          ...(action.key === 0 ? [] : state.data.slice(0, action.key)),
          ...(action.key === state.data.length - 1 ? [] : state.data.slice(action.key + 1))
        ],
        address: state.data.length <= 1 ? null : state.address,
        customer: state.data.length <= 1 ? null : state.customer,
        delivery_type: state.data.length <= 1 ? null : state.delivery_type,
        object_type: state.data.length <= 1 ? null : state.object_type
      });

    case CLEAR_PRODUCT_DELIVERY:
      return _.assign({}, state, {
        products: []
      });

    case CREATE_DELIVERYS_SUCCEEDED:
      return _.assign({}, state, {
        created: true,
        data: [],
        address: null,
        customer: null,
        delivery_type: null,
        object_type: null
      });

    default:
      return state;
  }
};
